import { COLUMN_DURATION, COLUMN_DURATION_WARNING, COLUMN_END_DATE, COLUMN_NAME, COLUMN_START_DATE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const ExpiryReasonColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "erName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Duration",
        accessor: "duration",
        isNumeric: false,
        id: 1,
        sortByName: "erDuration",
        sortDirection: "asc",
        active: true,
        translationKey: "duration",
        columnId: COLUMN_DURATION,
    },
    {
        heading: "Duration Warning",
        accessor: "durationWarning",
        isNumeric: false,
        id: 2,
        sortByName: "erDurationWarn",
        sortDirection: "asc",
        active: true,
        translationKey: "durationWarning",
        columnId: COLUMN_DURATION_WARNING
    },
    {
        heading: "Start Date",
        accessor: "masterExpiryStartDate",
        isNumeric: false,
        id: 3,
        sortDirection: "asc",
        active: true,
        translationKey: "startDate",
        columnId: COLUMN_START_DATE,
    },
    {
        heading: "End Date",
        accessor: "masterExpiryEndDate",
        isNumeric: false,
        id: 4,
        sortDirection: "asc",
        active: true,
        translationKey: "endDate",
        columnId: COLUMN_END_DATE,
    },
    {
        heading: "Event - Expiry",
        accessor: "eventExpiry",
        isNumeric: false,
        id: 5,
        sortDirection: "asc",
        active: true,
        translationKey: "eventExpiry",
    },
    {
        heading: "Event - Warning",
        accessor: "eventWarning",
        isNumeric: false,
        id: 6,
        sortDirection: "asc",
        active: true,
        translationKey: "eventWarning",
    },
    {
        heading: "Members",
        accessor: "totalMasterExpiries",
        isNumeric: true,
        id: 7,
        active: true,
        translationKey: "members"
    },
];

export default ExpiryReasonColumns;
